import { apiClient } from './apiClient';
import { authService } from '@/services/authService.ts';

export interface WartungsfensterStatus {
  aktiv: boolean;
  meldung: string | null;
}

class WartungsfensterService {
  private checkInterval: number | null = null;
  private lastStatus: WartungsfensterStatus = {
    aktiv: false,
    meldung: null
  };

  /**
   * Prüft den aktuellen Status des Wartungsfensters
   */
  async checkStatus(): Promise<WartungsfensterStatus> {
    try {
      // Wenn nicht eingeloggt, dann immer nicht aktiv
      const mandant = authService.getMandant();
      if (!mandant) {
        return {
          aktiv: false,
          meldung: null
        };
      }

      const response = await apiClient.get<WartungsfensterStatus>('/v1/wartungsfenster/status');
      return response.data;
    } catch {
      return {
        aktiv: false,
        meldung: null
      };
    }
  }

  /**
   * Startet das Polling des Wartungsfenster-Status
   * @param callback Callback-Funktion die bei Statusänderungen aufgerufen wird
   * @param intervalMs Polling-Intervall in Millisekunden (Standard: 60000 = 1 Minute)
   */
  startPolling(
    callback: (status: WartungsfensterStatus) => void,
    intervalMs: number = 60000
  ): void {
    // Verhindere doppeltes Polling
    if (this.checkInterval !== null) {
      this.stopPolling();
    }

    // Initial-Check
    this.checkStatus().then((status) => {
      callback(status);
    });

    // Setze Intervall
    this.checkInterval = window.setInterval(async () => {
      const newStatus = await this.checkStatus();

      // Rufe Callback nur auf wenn sich der Status geändert hat
      if (newStatus.aktiv !== this.lastStatus.aktiv) {
        this.lastStatus = newStatus;
        callback(newStatus);
      }
    }, intervalMs);
  }

  /**
   * Stoppt das Polling
   */
  stopPolling(): void {
    if (this.checkInterval !== null) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }
  }
}

export const wartungsfensterService = new WartungsfensterService();
